<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#f43443"
    :border="true"
    inactive-color="#979799"
  >
  <!-- 首页 -->
    <van-tabbar-item to="/home">
      <span class="site-footer__footer-label">{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/home.png?d='+new Date()*1 : '/img/footer/home.jpg?d='+new Date()*1"
          :alt="$t('foorter.index')"
          v-show="show !== 0"
        />
        <img
          :src="props.active ? '/img/footer/home.png?d='+new Date()*1 : '/img/footer/home.jpg?d='+new Date()*1"
          :alt="$t('foorter.index')"
          :class="$t('foorter.index')"
          style="height: 4rem"
          v-show="show === 0"
        />
      </template>
    </van-tabbar-item>
    <!-- 预约 -->
    <van-tabbar-item to="/games">
      <span class="site-footer__footer-label">{{ $t("foorter.subscribe") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/reserve.png?d='+new Date()*1 : '/img/footer/game.jpg?d='+new Date()*1"
          :alt="$t('foorter.subscribe')"
          v-show="show !== 1"
        />
        <img
          :src="props.active ? '/img/footer/reserve.png?d='+new Date()*1 : '/img/footer/game.jpg?d='+new Date()*1"
          :alt="$t('foorter.subscribe')"
          :class="$t('foorter.subscribe')"
          style="height: 4rem"
          v-show="show === 1"
        />
      </template>
    </van-tabbar-item>
    <!-- 中间 -->
    <!-- <van-tabbar-item to="/profiles">
      <span></span>
      <template #icon="props">
        <img class="site-footer__tui"
          :src="props.active ? '/img/footer/beauty3.png?d='+new Date()*1 : '/img/footer/beauty3.png?d='+new Date()*1"
        />
      </template>
    </van-tabbar-item> -->
    <!-- 视频 -->
    <!-- <van-tabbar-item to="/videos">
      <span class="site-footer__footer-label">{{ $t("foorter.video") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/vodeo_active.jpg?d='+new Date()*1 : '/img/footer/video.jpg?d='+new Date()*1"
          :alt="$t('foorter.video')"
          v-show="show !== 3"
        />
        <img
          :src="props.active ? '/img/footer/vodeo_active.jpg?d='+new Date()*1 : '/img/footer/video.jpg?d='+new Date()*1"
          :alt="$t('foorter.video')"
          :class="$t('foorter.video')"
          style="height: 4rem"
          v-show="show === 3"
        />
      </template>
    </van-tabbar-item> -->
    <!-- 我的 -->
    <van-tabbar-item to="/account">
      <span class="site-footer__footer-label">{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/my.png?d='+new Date()*1 : '/img/footer/mine.jpg?d='+new Date()*1"
          :alt="$t('foorter.my')"
          v-show="show !== 4"
        />
        <img
          :src="props.active ? '/img/footer/my.png?d='+new Date()*1 : '/img/footer/mine.jpg?d='+new Date()*1"
          :alt="$t('foorter.my')"
          :class="$t('foorter.my')"
          style="height: 4rem"
          v-show="show === 4"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {},
  watch: {
    $route(to) {
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "games") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "profiles") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "videos") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "account") {
        this.active = 2;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "games") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "profiles") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "videos") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "account") {
      this.active = 2;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped src="./Footer.styles.less"></style>
